import React from 'react';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Fade from '@material-ui/core/Fade';
import Backdrop from '@material-ui/core/Backdrop';

export default class EhcParticipantResultResend extends React.Component {
  constructor(props) {
    super(props);
    this.state = { submitting: false, error: null };
  }

  baseUrl = (company_id) => {
    if (Array.isArray(company_id)) company_id = null;
    return `/api/ehc/${company_id ? `companies/${company_id}/` : ''}participants`;
  };

  handleResend = async (event) => {
    event.preventDefault();

    const participant = this.props.participant;
    if (!participant || this.state.submitting) return;

    this.setState({ submitting: true, error: null });

    const url = `${this.baseUrl(participant.company_id)}/${participant.id}/resend_result`;
    const csrfToken = document.querySelector('[name=csrf-token]').content;

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-type': 'application/json; charset: UTF-8',
          'X-CSRF-Token': csrfToken
        }
      });
      const result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error(result.errors || `HTTP error! Status: ${response.status}`);
      }

      this.setState({ submitting: false });
      this.props.onClose();
      if (this.props.tableRef?.current) this.props.tableRef.current.onQueryChange();
    } catch (err) {
      this.setState({ submitting: false, error: err.message });
    }
  };

  render() {
    const participant = this.props.participant;

    return (
      <Modal
        open={this.props.open}
        onClose={this.props.onClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Fade in={this.props.open} timeout={500}>
          <Box
            display="flex"
            flexDirection="column"
            bgcolor="#fff"
            p={4}
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              outline: 'none',
              borderRadius: '4px',
              minWidth: '360px',
              maxWidth: '420px'
            }}
          >
            <form onSubmit={this.handleResend}>
              <Typography variant="h6" gutterBottom>
                Resend result email?
              </Typography>
              {participant &&
                <Typography variant="body2" className="text-muted mb-3">
                  The result email will be resent to{' '}
                  <strong>{participant.employee_email || participant.profile_email}</strong>
                  {participant.profile_full_name ? ` (${participant.profile_full_name})` : ''}.
                </Typography>
              }

              {this.state.error &&
                <div className="mb-3 text-red">{this.state.error}</div>
              }

              <Box className="d-flex justify-content-end">
                <Button
                  variant="outlined"
                  onClick={this.props.onClose}
                  className="mr-2"
                  disabled={this.state.submitting}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={this.state.submitting || !participant}
                >
                  {this.state.submitting ? 'Sending...' : 'Confirm Resend'}
                </Button>
              </Box>
            </form>
          </Box>
        </Fade>
      </Modal>
    );
  }
}
